import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './index.scss';

export default class ListPaginationInfo extends PureComponent {
  static defaultProps = {
    currentPage: 0,
    totalPages: 0,
    totalResults: 0,
    getPageLabel: (page, total) =>
      `${page} / ${total} ${total > 1 ? 'pages' : 'page'}`,
    getSelectedLabel: (count) => `${count} selected`,
    getEntityLabel: (count) =>
      `${count} ${count > 1 ? 'entities' : 'entity'} in total`,
  };

  render() {
    const {
      currentPage,
      totalPages,
      totalResults,
      selected,
      getPageLabel,
      getSelectedLabel,
      getEntityLabel,
    } = this.props;
    return (
      <div className="ListPaginationInfo">
        <div className="ListPaginationInfo__background" />
        <div className="ListPaginationInfo__content">
          <span className="ListPaginationInfo__text ListPaginationInfo__pages">
            {getPageLabel(totalPages === 0 ? 0 : currentPage, totalPages)}
          </span>
          <i className="ListPaginationInfo__circle mdi mdi-checkbox-blank-circle" />
          <span
            className="ListPaginationInfo__text ListPaginationInfo__total"
            data-total={totalResults}
          >
            {getEntityLabel(totalResults)}
          </span>
          {selected >= 0
            ? [
                <i
                  key="circle"
                  className="ListPaginationInfo__circle mdi mdi-checkbox-blank-circle"
                />,
                <span
                  key="text"
                  className="ListPaginationInfo__text ListPaginationInfo__selected"
                >
                  {getSelectedLabel(selected)}
                </span>,
              ]
            : null}
        </div>
      </div>
    );
  }
}

ListPaginationInfo.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalResults: PropTypes.number,
  selected: PropTypes.number,
  getPageLabel: PropTypes.func,
  getSelectedLabel: PropTypes.func,
  getEntityLabel: PropTypes.func,
};
